import type {CohortFormQuestionType} from '@cohort/shared/schema/common/cohortForm';
import {formatDate} from '@cohort/shared/utils/format';

export const formatCohortFormResponse = (
  questionType: CohortFormQuestionType,
  response: string | number | boolean | Date | null | undefined
): string => {
  if (response === undefined || response === null || response === '') {
    return '-';
  }
  if (questionType === 'date') {
    return formatDate(new Date(response.toString()));
  }
  return response.toString();
};
